import {
  ERR_OK,
  createFrame,
  isStr,
  getWindow
} from '../util';
let theWindow = getWindow();

let schema = 'didibridge://BRIDGE_CALL?callback=';
let msgFrame = null;

let __uid = 0;

export function callIOS(fn, param, callback) {
  let id = __uid++;
  let callbackName = '__bridgeCall__' + id;

  let callData = JSON.stringify({
    cmd: fn,
    id,
    params: param,
    callback: callbackName
  });

  let callDataName = '__getCallData__' + id;
  theWindow[callDataName] = function () {
    theWindow[callDataName] = function () {};
    return callData;
  };

  theWindow[callbackName] = function (retData) {
    if (isStr(retData)) {
      try {
        retData = JSON.parse(retData);
      } catch (e) {
        retData = {};
      }
    }
    let errno = retData.errno;
    let err = null;
    if (errno !== ERR_OK) {
      let msg = retData.errmsg;
      err = new Error(msg);
    }
    theWindow[callbackName] = function () {};
    // for beatles callback ret json string
    callback.length === 1 ? callback(JSON.stringify(retData.result)) : callback(err, retData.result);
  };

  // do send
  let src = schema + callDataName;
  send(src);
};

function send(src) {
  if (!msgFrame) {
    msgFrame = createFrame(src);
  } else {
    msgFrame.src = src;
  }
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/core/ios.js